/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/cognitive-complexity */

'use strict';

var addressHelpers = require('./address');
var cleave = require('../components/cleave');
var formHelpers = require('./formErrors');
var utils = require('../utils');
const clientSideValidation = require('../components/clientSideValidation');

/**
 * Validates the billing field on blur out event.
 * @returns {void}
 */
function validateBillingBlur() {
    var textInputFields = '.billing-address input, '
        + '.billing-address select, '
        + '.credit-card-content input, '
        + '.promo-section input, '
        + '.giftcard-section input, '
        + '.iban-number-wrapper input';

    $('body').on('blur', textInputFields, function (event) {
        clientSideValidation.functions.handleOnBlur.apply(this, [event]);
    });
}

/**
 * Grab the current email from the shipping section
 * @returns {string} the shipping email or an empty string
 */
function getShippingEmail() {
    var shippingEmails = $('.shippingEmail').filter(function (idx, email) {
        return $(email).val().length > 0;
    });
    // TODO...for now, just use the first value found...this will probably need to be adjusted for multiship if there are multiple shipping email address fields containing values
    return shippingEmails.length > 0 ? $(shippingEmails[0]).val() : '';
}

/**
 * updates the billing address selector within billing forms
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateBillingAddressSelector(order, customer) {
    var shippings = order.shipping;

    var form = $('form[name$=billing]')[0];
    var $billingAddressSelector = $('.addressSelector', form);
    var hasSelectedAddress = false;

    if ($billingAddressSelector && $billingAddressSelector.length === 1) {
        $billingAddressSelector.empty();
        // Add New Address option
        $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            null,
            false,
            order,
            { type: 'billing' }
        ));

        // Separator -
        $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            order.resources.shippingAddresses, false, order, {
                // className: 'multi-shipping',
                type: 'billing'
            }
        ));

        shippings.forEach(function (aShipping) {
            if (
                (!aShipping.selectedShippingMethod || !aShipping.selectedShippingMethod.storePickupEnabled)
                || !window.sitePrefs.bopisEnabled
            ) {
                var isSelected = order.billing.matchingAddressId === aShipping.UUID;
                hasSelectedAddress = hasSelectedAddress || isSelected;
                // Shipping Address option
                $billingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress(aShipping, isSelected, order,
                        {
                            // className: 'multi-shipping',
                            type: 'billing'
                        })
                );
            }
        });

        if (customer.addresses && customer.addresses.length > 0) {
            $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.accountAddresses, false, order
            ));
            customer.addresses.forEach(function (address) {
                var isSelected = order.billing.matchingAddressId === address.ID;
                hasSelectedAddress = hasSelectedAddress || isSelected;
                // Customer Address option
                $billingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress({
                        UUID: 'ab_' + address.ID,
                        shippingAddress: address
                    }, isSelected, order, { type: 'billing' })
                );
            });
        }
    }

    if (hasSelectedAddress
        || (!order.billing.matchingAddressId && order.billing.billingAddress.address)) {
        // show
        $(form).attr('data-address-mode', 'edit');
    } else {
        $(form).attr('data-address-mode', 'new');
    }

    $billingAddressSelector.show();
}

/**
 * updates the billing address form values within payment forms
 * @param {Object} order - the order model
 */
function updateBillingAddressFormValues(order) {
    var billing = order.billing;
    if (!billing.billingAddress || !billing.billingAddress.address) return;

    var form = $('form[name=dwfrm_billing]');
    if (!form) return;

    if (!order.orderEmail) {
        order.orderEmail = $('#billingemail').val() || getShippingEmail(); // eslint-disable-line no-param-reassign
    }

    $('input[name$=_firstName]', form).val(billing.billingAddress.address.firstName);
    $('input[name$=_lastName]', form).val(billing.billingAddress.address.lastName);
    if (billing.billingAddress.address.firstNamePhonetic) {
        $('input[name$=_firstNamePhonetic]', form).val(billing.billingAddress.address.firstNamePhonetic);
    }
    if (billing.billingAddress.address.lastNamePhonetic) {
        $('input[name$=_lastNamePhonetic]', form).val(billing.billingAddress.address.lastNamePhonetic);
    }
    $('input[name$=_address1]', form).val(billing.billingAddress.address.address1);
    $('input[name$=_address2]', form).val(billing.billingAddress.address.address2);
    $('input[name$=_address3]', form).val(billing.billingAddress.address.address3);
    $('select[name$=_city],input[name$=_city]', form).val(billing.billingAddress.address.city);
    $('select[name$=_postalCode],input[name$=_postalCode]', form).val(billing.billingAddress.address.postalCode);
    $('select[name$=_stateCode],input[name$=_stateCode]', form)
        .val(billing.billingAddress.address.stateCode);
    $('select[name$=_country]', form).val(billing.billingAddress.address.countryCode.value);
    $('input[name$=_phone]', form).val(billing.billingAddress.address.phone);
    $('input[name$=_email]', form).val(order.orderEmail);
    $('select[name$=_phoneCode]', form).val(billing.billingAddress.address.phoneCode);

    if (billing.payment && billing.payment.selectedPaymentInstruments
        && billing.payment.selectedPaymentInstruments.length > 0) {
        var instrument = billing.payment.selectedPaymentInstruments[0];
        $('select[name$=expirationMonth]', form).val(instrument.expirationMonth);
        $('select[name$=expirationYear]', form).val(instrument.expirationYear);
        // Force security code and card number clear
        $('input[name$=securityCode]', form).val('');
        if ($('input[name$=cardNumber]').length > 0) {
            $('input[name$=cardNumber]').data('cleave').setRawValue('');
        }
    }
}

/**
 * clears the billing address form values
 */
function clearBillingAddressFormValues() {
    var form = $('form[name=dwfrm_shipping]');
    var countryValue = $('select[name$=_country] option:selected', form).val();

    updateBillingAddressFormValues({
        billing: {
            billingAddress: {
                address: {
                    countryCode: {
                        value: countryValue
                    }
                }
            }
        }
    });
}

/**
 * Updates the billing information in checkout, based on the supplied order model
 * @param {Object} order - checkout model to use as basis of new truth
 * @param {Object} customer - customer model to use as basis of new truth
 * @param {Object} [options] - options
 */
function updateBillingInformation(order, customer) {
    updateBillingAddressSelector(order, customer);

    // update billing address form
    updateBillingAddressFormValues(order);

    // update billing address summary
    addressHelpers.methods.populateAddressSummary('.billing .address-summary',
        order.billing.billingAddress.address);

    // update billing parts of order summary
    $('.order-summary-email').text(order.orderEmail);

    // Update phone number
    if (order.billing.billingAddress.address) {
        $('.billing-phone').removeClass('d-none').addClass('d-flex');
        var summaryPhone = order.billing.billingAddress.address.phone;
        if (order.billing.billingAddress.address.phoneCode) {
            summaryPhone = order.billing.billingAddress.address.phoneCode
                + ' '
                + order.billing.billingAddress.address.phone;
        }
        $('.order-summary-phone').text(summaryPhone);
    }
}

/**
 * togglePaymentMethod
 * @param {Object} paymentMethod SFRA payment model
 */
function togglePaymentMethodBySelectedShippingMethod(paymentMethod) {
    var paymentMethodEl = $('[data-method-id="' + paymentMethod.ID + '"]');
    if (paymentMethodEl.length > 0) {
        // if already hidden because of another functionality leave it as-is
        var isAlreadyHidden = paymentMethodEl.hasClass('d-none');
        if (!isAlreadyHidden) {
            if (paymentMethod.hide) {
                paymentMethodEl.removeClass('d-flex').addClass('hide-payment-method-if-shipping-method');
            } else {
                paymentMethodEl.addClass('d-flex').removeClass('hide-payment-method-if-shipping-method');
            }
        }
    }
}

/**
 * handlePaymentMethodVisibility
 * @param {Object} order SFRA order model
 */
function handlePaymentMethodVisibility(order) {
    if (order && order.billing && order.billing.payment && order.billing.payment.enablePaymentMethodFilteringByShippingMethod
        && order.billing.payment.applicablePaymentMethods && order.billing.payment.applicablePaymentMethods.length > 0) {
        var applicablePaymentMethods = order.billing.payment.applicablePaymentMethods;
        applicablePaymentMethods.filter(function (apm) {
            return apm.ID !== 'AdyenComponent'; // remove container payment methods like AdyenComponent as they are always hidden from the customer
        }).forEach(togglePaymentMethodBySelectedShippingMethod);
    }
}

/**
 * Updates the payment information in checkout, based on the supplied order model
 * NOTE: This function is also called from giftCard.js as well
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updatePaymentInformation(order) {
    // update payment details
    var $paymentSummary = $('.payment-details');
    var htmlToAppend = '';

    handlePaymentMethodVisibility(order);

    if (order.billing.payment && order.billing.payment.selectedPaymentInstruments
        && order.billing.payment.selectedPaymentInstruments.length > 0) {
        for (var i = 0; i < order.billing.payment.selectedPaymentInstruments.length; i) {
            var paymentInstrument = order.billing.payment.selectedPaymentInstruments[i];
            $('.cash-on-delivery-fee').addClass('hide-cashondelivery-discount');
            if (paymentInstrument.paymentMethod === 'GIFT_CERTIFICATE') {
                // Render a gift card payment instrument
                htmlToAppend += '<span> ' + order.resources.giftCardTypeLabel
                    + '</span><div>'
                    + paymentInstrument.maskedGiftCertificateCode
                    + '</div><div><span>'
                    + '</span></div>';
            } else if (paymentInstrument.paymentMethod === 'AFTERPAY_PBI') {
                htmlToAppend += '<span class="font-body regular">' + order.resources.afterpaySummary + '</span>';
            } else if (paymentInstrument.paymentMethod === 'PayPal') {
                htmlToAppend += '<span class="font-body regular">' + order.resources.paypalSummary + '</span>';
            } else if (paymentInstrument.paymentMethod === 'ECPAY') {
                htmlToAppend += '<span class="font-body regular">' + order.resources.ecpaySummary + '</span>';
            } else if (paymentInstrument.paymentMethod === 'PEACH' || paymentInstrument.paymentMethod === 'PEACH_CAP') {
                htmlToAppend += '<span class="font-body regular">' + order.resources.peachSummary + '</span>';
            } else if (paymentInstrument.paymentMethod === 'AdyenComponent') {
                htmlToAppend += '<div class="d-flex flex-column"><span class="font-body regular">' + paymentInstrument.selectedAdyenPM + '</span></div>';
            } else if (paymentInstrument.paymentMethod === 'CASH_ON_DELIVERY') {
                htmlToAppend += '<div class="d-flex flex-column"><span class="font-body regular">' + order.resources.cashOnDeliveryPaymentMethod + '</span></div>';
                if (order.totals?.cashOnDeliveryFee?.formatted) {
                    $('.cash-on-delivery-fee').removeClass('hide-cashondelivery-discount');
                    $('.cashondelivery-total-cost').empty().append(order.totals.cashOnDeliveryFee.formatted);
                }
            } else if (paymentInstrument.paymentMethod === 'AMAZON_PAY') {
                htmlToAppend += '<div class="d-flex flex-column"><span class="font-body regular">' + order.resources.amazonPaySummary + '</span></div>';
            } else if (paymentInstrument.paymentMethod === 'PAIDY') {
                htmlToAppend += '<div class="d-flex flex-column"><span class="font-body regular">' + order.resources.paidySummary + '</span></div>';
            } else if (paymentInstrument.paymentMethod === 'LOYALTY_POINT') {
                htmlToAppend += '<div class="d-flex flex-column"><span class="font-body regular">' + order.resources.loyaltyPointSummary + '</span></div>';
            } else if (paymentInstrument.paymentMethod === 'TABBY') {
                htmlToAppend += '<div class="d-flex flex-column"><span class="font-body regular">' + order.resources.tabbySummary + '</span></div>';
            } else {
                // Assume the existing logic (always use CC) works here
                htmlToAppend
                    += '<div class="d-flex flex-column"><span class="font-body"> '
                    + paymentInstrument.type
                    + '</span>';
                if (paymentInstrument.maskedCreditCardNumber) {
                    htmlToAppend
                        += '<span class="font-body">'
                        + paymentInstrument.maskedCreditCardNumber
                        + '</span></div>';
                }
            }
            i += 1;
        }
    }

    $paymentSummary.empty().append(htmlToAppend);
}

/**
 * clears the credit card form
 */
function clearCreditCardForm() {
    if ($('input[name$="_cardNumber"]').length > 0) {
        $('input[name$="_cardNumber"]').data('cleave').setRawValue('');
    }
    $('select[name$="_expirationMonth"]').val('');
    $('select[name$="_expirationYear"]').val('');
    $('input[name$="_securityCode"]').val('');
    $('input[name$="expMonthYear"]').val('');
    $('#saveCreditCard').prop('checked', false);
}

/**
 * Update selected card details
 * @param {boolean} secCode CVV no
 */
function updateSavedCardTemplate(secCode) {
    var $storedPayments = $('.stored-payments');
    if ($storedPayments.length) {
        var defaultCard = $storedPayments.find('.saved-payment-instrument.selected-payment');
        if (defaultCard.length) {
            var $selectedCardDisplay = $('.selected-card-display');
            var cardType = $(defaultCard).data('creditCardType');
            var cardNumber = $(defaultCard).data('cardNumber');
            var expiry = $(defaultCard).data('expiry');
            var uniquePaymentId = $(defaultCard).data('uuid');
            var selectedCardPaymentId = 'saved_' + uniquePaymentId;
            var savedSecurityCodeContent = $(defaultCard).find('.saved-security-code').html();
            var displayDetails = '<div class="d-lg-flex"><span class="pr-3">'
                + cardType
                + ' Credit Card </span><span>'
                + cardNumber
                + ', expires on '
                + expiry
                + '</span></div><div class="invalid-feedback" id="expiredCardMessage"></div>';
            if ($selectedCardDisplay.length) {
                $selectedCardDisplay.empty().append(displayDetails, savedSecurityCodeContent);
                var $savedPaymentSecurityCode = $selectedCardDisplay.find('.saved-payment-security-code');
                var $savedPaymentLabel = $selectedCardDisplay.find('.saved-payment-label');
                if ($savedPaymentSecurityCode.length) {
                    $savedPaymentSecurityCode.val(secCode);
                    $savedPaymentLabel.attr('for', selectedCardPaymentId);
                    $savedPaymentSecurityCode.attr('id', selectedCardPaymentId);
                }
            }
            $storedPayments.attr('aria-activedescendant', $(defaultCard).attr('id'));
        }
    }
}

/**
 * Check saved cards in user account
 */
function handleSavedCardsDropdown() {
    var $userPayments = $('.user-payment-instruments');
    var $storedPayments = $('.stored-payments');
    if ($userPayments.length && $storedPayments.length) {
        var totalSavedCards = $storedPayments.children('.saved-payment-instrument').length;
        if (totalSavedCards && totalSavedCards === 1) {
            $userPayments.addClass('only-saved-card');
            return;
        }
        $userPayments.removeClass('only-saved-card');
    }
}

/**
 * Function used to hide and show billing address section
 * @param {boolean} enable to hide or show
 */
function disableBillingForm(enable) {
    $('select[name$="_country"]').prop('disabled', enable);
    $('input[name$="_firstName"]').prop('disabled', enable);
    $('input[name$="_lastName"]').prop('disabled', enable);
    $('input[name$="_firstNamePhonetic"]').prop('disabled', enable);
    $('input[name$="_lastNamePhonetic"]').prop('disabled', enable);
    $('input[name$="_address1"]').prop('disabled', enable);
    $('input[name$="_address2"]').prop('disabled', enable);
    $('input[name$="_address3"]').prop('disabled', enable);
    $('input[name$="_city"]').prop('disabled', enable);
    $('select[name$="_stateCode"]').prop('disabled', enable);
    $('input[name$="_postalCode"]').prop('disabled', enable);
    $('input[name$="_email"]').prop('disabled', enable);
    $('input[name$="_phone"]').prop('disabled', enable);
    if (enable) $('.billing-address').addClass('d-none');
    else $('.billing-address').removeClass('d-none');
}

/**
 * Function used to enable and disable CC fields
 * @param {boolean} enable to hide or show
 */
function disableCrediCardForm(enable) {
    $('select[name$="_expirationMonth"]').prop('disabled', enable);
    $('select[name$="_expirationYear"]').prop('disabled', enable);
    $('input[name$="_cardNumber"]').prop('disabled', enable);
    $('input[name$="_securityCode"]').prop('disabled', enable);
}

/**
 * Determines if the order has a payment (instrument) applied matching paymentMethodID
 * @param {Object} orderModel @ org_newbalance/cartridges/org_newbalance/cartridge/models/order.js
 * @param {string} paymentMethodID the ID of the payment method
 * @returns {boolean} returns true if the order has a payment applied with the paymentMethodID
 */
function orderHasPaymentMethodInstrument(orderModel, paymentMethodID) {
    var selectedPaymentInstruments = orderModel?.billing?.payment?.selectedPaymentInstruments ?? [];
    return selectedPaymentInstruments.some(payInstrument => payInstrument.paymentMethod === paymentMethodID);
}

module.exports = {
    methods: {
        updateBillingAddressSelector: updateBillingAddressSelector,
        updateBillingAddressFormValues: updateBillingAddressFormValues,
        clearBillingAddressFormValues: clearBillingAddressFormValues,
        updateBillingInformation: updateBillingInformation,
        updatePaymentInformation: updatePaymentInformation,
        clearCreditCardForm: clearCreditCardForm,
        updateSavedCardTemplate: updateSavedCardTemplate,
        handleSavedCardsDropdown: handleSavedCardsDropdown,
        getShippingEmail: getShippingEmail,
        disableCrediCardForm: disableCrediCardForm,
        orderHasPaymentMethodInstrument: orderHasPaymentMethodInstrument
    },
    isEGiftCard: function () {
        var $billingAddressSelector = $('.billingAddressSelector');
        var $billingAddress = $('.billing-address-block .billing-address');
        var isYamatoPickup = $('form.billing-information').data('isyamatopickup');
        var isAmzPayExpressFlow = $('#checkout-main').attr('data-is-amzpay-expressflow') === 'true';

        if ($('.is-egiftcard').length) {
            if (!$billingAddressSelector.find('.selected-option div').length) {
                $billingAddress.addClass('d-block');
                $billingAddressSelector.addClass('d-none');
            }
        } else if ($billingAddress.hasClass('d-block') && !isYamatoPickup && !isAmzPayExpressFlow) {
            $billingAddress.removeClass('d-block');
            if ($billingAddressSelector.hasClass('d-none')) {
                $billingAddressSelector.removeClass('d-none');
            }
        }
    },

    showBillingDetails: function () {
        $('.btn-show-billing-details').on('click', function () {
            $(this).parents('[data-address-mode]').attr('data-address-mode', 'new');
        });
    },

    hideBillingDetails: function () {
        $('.btn-hide-billing-details').on('click', function () {
            $(this).parents('[data-address-mode]').attr('data-address-mode', 'shipment');
        });
    },

    selectBillingAddress: function () {
        $('.payment-form .addressSelector').on('change', function () {
            var form = $(this).parents('form')[0];
            var selectedOption = $('option:selected', this);
            var optionID = selectedOption[0].value;

            if (optionID === 'new') {
                // Show Address
                $(form).attr('data-address-mode', 'new');
            } else {
                // Hide Address
                $(form).attr('data-address-mode', 'shipment');
            }

            // Copy fields
            var attrs = selectedOption.data();
            var element;

            // update the country field first if difference between form and selected option
            if (
                attrs
                && attrs.countryCode
                && attrs.countryCode !== null
                && $('[name$=country]', form).val() !== attrs.countryCode
            ) {
                $('[name$=country]', form).val(attrs.countryCode).change();
            }

            // update the form based on selected country
            $.when($('.billing-address #billingCountry').triggerHandler('change')).then(function () {
                // update the fields with the values from the selected option
                // do here and below to ensure that the fields are populated correctly with dynamic forms
                Object.keys(attrs).forEach(function (attr) {
                    element = attr === 'countryCode' ? 'country' : attr;
                    if (element === 'cardNumber') {
                        $('.cardNumber').data('cleave').setRawValue(attrs[attr]);
                    } else if (element === 'stateCode') {
                        if ($('[name$=city]', form).val()) {
                            $('[name$=' + element + ']', form).val(attrs[attr]);
                        } else {
                            // set state and trigger that change handler
                            $('[name$=' + element + ']', form).val(attrs[attr]).change();
                            // set the city value for dynamic city drop downs
                            $('[name$=city]', form).val(attrs.city);
                            if (!$('[name$=postalCode]', form).val()) {
                                // set the postalCode value for dynamic postalCode drop downs
                                $('[name$=postalCode]', form).val(attrs.postalCode);
                            }
                        }
                    } else {
                        $('[name$=' + element + ']', form).val(attrs[attr]);
                    }
                });
            });

            // update the fields with the values from the selected option
            Object.keys(attrs).forEach(function (attr) {
                element = attr === 'countryCode' ? 'country' : attr;
                if (element === 'cardNumber') {
                    $('.cardNumber').data('cleave').setRawValue(attrs[attr]);
                } else if (element === 'stateCode') {
                    if ($('[name$=city]', form).val()) {
                        $('[name$=' + element + ']', form).val(attrs[attr]);
                    } else {
                        // set state and trigger that change handler
                        $('[name$=' + element + ']', form).val(attrs[attr]).change();
                        // set the city value first for dynamic city drop downs
                        $('[name$=city]', form).val(attrs.city);
                        if (!$('[name$=postalCode]', form).val()) {
                            // set the postalCode value for dynamic postalCode drop downs
                            $('[name$=postalCode]', form).val(attrs.postalCode);
                        }
                    }
                } else {
                    $('[name$=' + element + ']', form).val(attrs[attr]);
                }
            });
        });
    },

    handleCreditCardNumber: function () {
        cleave.handleCreditCardNumber('.cardNumber', '#cardType');
    },

    santitizeForm: function () {
        $('body').on('checkout:serializeBilling', function (e, data) {
            var serializedForm = cleave.serializeData(data.form);

            data.callback(serializedForm);
        });
    },

    selectSavedPaymentInstrument: function () {
        $('.stored-payments').on('click keydown', 'li.saved-payment-instrument', function (e) {
            var eventType = e.type;
            var keyCode = e.which || e.keyCode;
            if (eventType === 'click' || keyCode === utils.ENTER_KEY_CODE) {
                e.preventDefault();
                e.stopPropagation();
                var $savedPaymentInstrument = $('.saved-payment-instrument');
                // copied from checkout
                $('.stored-payments li').find('.form-check-input').removeAttr('checked');
                $(this).find('.form-check-input').attr('checked', true);
                formHelpers.clearPreviousErrors('.payment-form');
                setTimeout(function () {
                    $('.payment-information').data('is-new-payment', false);
                    $('.credit-card-form').addClass('checkout-hidden');
                    $('.cvv-add-card').removeClass('checkout-hidden d-none');
                    $('.saved-payment-instrument.show-cvv-input').removeClass('d-none');
                    updateSavedCardTemplate();
                    // reinitiate tooltip
                    $('[data-toggle="tooltip"]').tooltip();
                }, 100);
                $('.selected-card-display').removeClass('active');

                $('.saved-payment-security-code').val('');
                $savedPaymentInstrument.removeClass('selected-payment').attr('aria-selected', false);
                $(this).addClass('selected-payment');
                $(this).attr('aria-selected', true);
                $savedPaymentInstrument.find('.card-image').removeClass('checkout-hidden');
                $savedPaymentInstrument.find('.security-code-input').addClass('checkout-hidden');
                $('.saved-payment-instrument.selected-payment'
                + ' .card-image').addClass('checkout-hidden');
                $('.saved-payment-instrument.selected-payment '
                + '.security-code-input').removeClass('checkout-hidden');
            }
        });
    },

    addNewPaymentInstrument: function () {
        $('button.add-payment').on('click', function (e) {
            e.preventDefault();
            $('.payment-information').data('is-new-payment', true);
            clearCreditCardForm();
            // clear previous errors any
            formHelpers.clearPreviousErrors('.credit-card-form');
            $('.credit-card-form').removeClass('checkout-hidden');
            $('.cvv-add-card').removeClass('d-flex').addClass('checkout-hidden');
            $('.credit-card-form').find('.invalid-feedback').removeAttr('style');
        });
    },

    cancelNewPayment: function () {
        $('.cancel-new-payment').on('click', function (e) {
            e.preventDefault();
            $('.payment-information').data('is-new-payment', false);
            clearCreditCardForm();
            $('.user-payment-instruments').removeClass('checkout-hidden');
            $('.credit-card-form').addClass('checkout-hidden');
            $('.cvv-add-card').addClass('d-flex').removeClass('checkout-hidden');
        });
    },

    clearBillingForm: function () {
        $('body').on('checkout:clearBillingForm', function () {
            clearBillingAddressFormValues();
        });
    },
    enterBillingAddress: function (selectedCountry) {
        var input = document.getElementById('billingaddress1');
        if (typeof google !== 'object' || !google.maps) { // eslint-disable-line no-undef
            return;
        }
        $('#billingaddress1').on('focus', function () {
            $(this).attr('autocomplete', 'new-password');
        });
        var countryRestrict = '';
        if ($('#billingCountry').val()) {
            var countryValue = $('#billingCountry').val().toLowerCase();
            countryRestrict = [countryValue];
        } else if ($('input[name$=countryListBilling]').val()) {
            countryRestrict = selectedCountry;
        }

        // Create the autocomplete object, restricting the search to geographical
        // location types.
        var options = {
            types: ['geocode'],
            componentRestrictions: { country: countryRestrict }
        };
        var autoComplete = new google.maps.places.Autocomplete(input, options); // eslint-disable-line no-undef
        autoComplete.addListener('place_changed', function () {
            var place = autoComplete.getPlace();
            var placeCountry;

            if (place.address_components) {
                if ($('#billingCountry').val()) {
                    placeCountry = $('#billingCountry').val();
                } else {
                    var tempCountry = $('.site-locale').val().split('_').pop(1);
                    placeCountry = tempCountry;
                }
                var billingAddrOne = document.getElementById('billingaddress1') || {};
                var billingAddrTwo = document.getElementById('billingaddress2') || {};
                var billingAddrCity;
                var billingState;
                var enteredBilingAddress = billingAddrOne.value;
                billingAddrOne.value = '';
                billingAddrTwo.value = '';
                for (var i = 0, len = place.address_components.length; i < len; i += 1) {
                    var component = place.address_components[i];
                    if (component.types[0] === 'street_number') {
                        billingAddrOne.value += component.long_name;
                        billingAddrOne.classList.add('text-entered');
                    } else if (component.types[0] === 'premise') {
                        billingAddrOne.value = component.long_name + ' ' + billingAddrOne.value;
                        billingAddrOne.classList.add('text-entered');
                    } else if (component.types[0] === 'route') {
                        if (enteredBilingAddress.indexOf(component.long_name) > 0) {
                            var firstOccurence = enteredBilingAddress.indexOf(component.long_name);
                            billingAddrOne.value = enteredBilingAddress.slice(0, firstOccurence);
                            billingAddrOne.value += component.long_name;
                            billingAddrOne.classList.add('text-entered');
                        } else {
                            billingAddrOne.value += component.long_name;
                            billingAddrOne.classList.add('text-entered');
                        }
                    } else if (component.types[0] === 'locality' || component.types[0] === 'postal_town') {
                        billingAddrCity = document.getElementById('billingcity');
                        billingAddrCity.value = component.long_name;
                        billingAddrCity.classList.add('text-entered');
                        billingAddrCity.classList.remove('is-invalid');
                    } else if (component.types[0] === 'administrative_area_level_2') {
                        if (placeCountry && (placeCountry === 'IT')) {
                            billingState = document.getElementById('billingstateCode');
                            if (billingState != null && billingState.length > 1) {
                                billingState.value = component.short_name;
                                billingState.classList.add('text-entered');
                                billingState.classList.remove('is-invalid');
                            }
                        }
                    } else if (component.types[0] === 'administrative_area_level_1') {
                        if (placeCountry && (placeCountry !== 'IT')) {
                            billingState = document.getElementById('billingstateCode');
                            if (billingState != null && billingState.length > 1) {
                                billingState.value = component.short_name;
                                billingState.classList.add('text-entered');
                                billingState.classList.remove('is-invalid');
                            }
                        }
                    } else if (component.types[0] === 'postal_code') {
                        var billingZipCode = document.getElementById('billingpostalCode');
                        billingZipCode.value = component.long_name;
                        billingZipCode.classList.add('text-entered');
                        billingZipCode.classList.remove('is-invalid');
                    } else if (component.types[0] === 'country') {
                        var billingCountry = document.getElementById('billingCountry');
                        billingCountry.value = component.short_name;
                        billingCountry.classList.add('text-entered');
                    } else if (component.types[0] === 'sublocality_level_2') {
                        var billingAddrThree = document.getElementById('billingaddress3');
                        billingAddrThree.value = component.short_name;
                        billingAddrThree.classList.add('text-entered');
                    }
                }
                $('#dwfrm_billing').trigger('change');
            }
        });
    },
    paymentTabs: function () {
        var $submitPayment = $('.submit-payment');
        var $paypalCheckoutButton = $('.paypal-checkout-button');
        var $addressSelectorBlock = $('.address-selector-block');
        var $jsNotBankTransfer = $('.js-not-banktransfer');
        var $savedPaymentCvv = $('.selected-card-display .saved-payment-security-code');
        var $savedPaymentInstruments = $('.user-payment-instruments');
        var initalText = $submitPayment.data('default-text');

        // GA4 click event for payment submit
        $submitPayment.on('click', function () {
            $(document).trigger('billing:submit-payment', {
                elementType: $(this)[0].nodeName,
                elementText: $(this).text().trim()
            });
        });

        // GA4 click event for paypal submit on billing
        $paypalCheckoutButton.on('click', function () {
            $(document).trigger('billing:submit-payment', {
                elementType: $(this)[0].nodeName,
                elementText: 'PayPal Checkout'
            });
        });

        $('body').on('click', '#paymentMethodsList .paymentMethod', function () { // Adyen payment method selected
            // Show Adyen Component forms
            $('.nav-item[data-method-id="AdyenComponent"]').trigger('click');
            $('#paymentMethodsList .additionalFields').hide();
            $(this).find('.additionalFields').show();
            $('input[name=brandCode]').prop('checked', false);
            $(this).find('input[name=brandCode]').prop('checked', true);
            $(this).find('input[name=brandCode]').trigger('change');

            // Clear non-Adyen selection
            $('.nav-link.active').removeClass('active');

            disableCrediCardForm(true);

            var newCreditCardOption = $(this).find('#rb_scheme');
            if (newCreditCardOption && newCreditCardOption.val() === 'scheme') {
                $('.form-control.cardNumber').attr('disabled', false);
            }
        });

        $('.payment-options .nav-item').on('click', function (e) {
            e.preventDefault();
            if ($(this).find('.nav-link') && $(this).find('a').hasClass('disabled')) {
                return;
            }
            $('.payment-section .tab-pane.active').removeClass('active');
            disableBillingForm(false);
            var methodID = $(this).data('method-id');

            if (methodID !== 'AdyenComponent') {
                // Hide Adyen Component forms
                $('#paymentMethodsList .additionalFields').hide();

                // Clear Adyen selection
                $('.adyen-tab').removeClass('active');
                $('.adyen-tab').attr('aria-selected', 'false');
                $('input[name=brandCode]').prop('checked', false);
                setTimeout(function () {
                    $('input[name=brandCode]').attr('disabled', false);
                }, 100);
            }

            $submitPayment.removeClass('d-none').removeAttr('style');
            var $currentTabContent = $($(this).find('a').attr('href'));
            $currentTabContent.find('input, textarea, select').prop('disabled', false);
            if ($savedPaymentCvv.length) {
                $savedPaymentCvv.removeClass('is-invalid');
            }
            clearCreditCardForm();
            formHelpers.clearPreviousErrors('.credit-card-form');
            $('#ecpay-description').remove();
            if ($('input[name="peacheft"]').length) {
                $('input[name="peacheft"]').val('false');
            }
            if (methodID === 'AFTERPAY_PBI') {
                $submitPayment.text($submitPayment.data('afterpay-text'));
                $addressSelectorBlock.removeClass('d-none');
                disableCrediCardForm(true);
            } else if (methodID === 'ECPAY') {
                var ecPayButtonText = $(this).data('button-text');
                var ecPayDescription = $(this).data('button-note');
                $submitPayment.text(ecPayButtonText);
                $(
                    '<div id="ecpay-description" class="mt-2">'
                    + ecPayDescription
                    + '</div>'
                ).insertAfter($submitPayment);
                $addressSelectorBlock.removeClass('d-none');
                disableCrediCardForm(true);
            } else if (methodID === 'PayPal') {
                disableBillingForm(true);
                $addressSelectorBlock.addClass('d-none');
                if ($('.js_paypal-use-another-account-wrap').length) {
                    $submitPayment.text(initalText);
                }
                disableCrediCardForm(true);
            } else if (methodID === 'DW_APPLE_PAY') {
                $addressSelectorBlock.addClass('d-none');
                $submitPayment.addClass('d-none');
                disableCrediCardForm(true);
            } else if (methodID === 'PEACH' || methodID === 'PEACH_CAP' || methodID === 'PEACH_EFT') {
                $addressSelectorBlock.removeClass('d-none');
                disableCrediCardForm(true);
                if (methodID === 'PEACH_EFT' && $('input[name="peacheft"]').length) {
                    $('input[name="peacheft"]').val('true');
                }
            } else if (methodID === 'PAYBYLINK') {
                $('.billing-address').addClass('d-none');
                $addressSelectorBlock.addClass('d-none');
            } else {
                $('#credit-card-content input[name*="billing_paymentMethod"]').val(methodID);
                var paymentMethodIds = ['ALIPAY', 'MCH', 'EPS', 'BANK_TRANSFER'];
                var paymentMethod = paymentMethodIds.indexOf(methodID) > -1;
                if (paymentMethod) {
                    $jsNotBankTransfer.addClass('d-none');
                    disableCrediCardForm(true);
                } else if (methodID === 'CREDIT_CARD') {
                    $jsNotBankTransfer.removeClass('d-none');

                    disableCrediCardForm(false);
                    // if user has saved credit card
                    if ($savedPaymentCvv.length) {
                        $('.credit-card-form').addClass('checkout-hidden');
                        $savedPaymentInstruments.removeClass('d-none');
                    }
                }
                $submitPayment.text(initalText);
                $addressSelectorBlock.removeClass('d-none');
            }
            $(document).trigger('selected-payment:method', $(this).find('a').attr('href').replace('#', ''));
            $('input[name$="paymentMethod"]').val(methodID);
            $('.payment-information').data('payment-method-id', methodID);
        });
    },
    savePaymentInstrument: function () {
        $(document).on('click', '.save-credit-card-btn', function (e) {
            e.preventDefault();
            var $form = $(this).closest('form');
            var secCode = $form.find('#securityCode').val();
            var reqUrl = $(this).data('saveCard');
            var creditCardFormData = $form.serialize();
            var $creditCardForm = $('.credit-card-form .add-card-form');
            formHelpers.clearPreviousErrors('.payment-form');
            var isCreditCardFormValid = clientSideValidation.functions.validatePartialForm($creditCardForm[0], e);
            if (!isCreditCardFormValid) {
                return;
            }
            $form.spinner().start();
            $.ajax({
                url: reqUrl,
                type: 'POST',
                data: creditCardFormData
            })
                .done(function (response) {
                    $form.spinner().stop();
                    var formSelector = '.billing-information';
                    formHelpers.clearPreviousErrors('.billing-information');
                    if (response.error) {
                        var data = response;
                        if (data.fieldErrors.length) {
                            data.fieldErrors.forEach(function (error) {
                                if (Object.keys(error).length) {
                                    formHelpers.loadFormErrors(formSelector, error);
                                    $(document).trigger('credit-card:error');
                                }
                            });
                        }
                    } else {
                        $('.credit-card-form').addClass('checkout-hidden');
                        $('.cvv-add-card').addClass('d-flex').removeClass('checkout-hidden');
                        var $storedPayments = $('.stored-payments');
                        if (response.renderedPaymentInstruments && $storedPayments.length) {
                            $storedPayments.empty().html(response.renderedPaymentInstruments);
                            updateSavedCardTemplate(secCode);
                            // reinitiate tooltip
                            $('[data-toggle="tooltip"]').tooltip();
                            handleSavedCardsDropdown();
                        }
                    }
                })
                .fail(function () {
                    $form.spinner().stop();
                });
        });
    },
    populateBillingEmail: function () {
        // This event triggers from dynamicAddress.js on country change
        $(document).on('checkout:updateBillingAddressForm', function () {
            // Make sure the shipping email persists on the billing form if one exists...note, this will not work if the page is manually  reloaded during the billing step
            $('form[name=dwfrm_billing] input[name$=_email]').val(getShippingEmail());
        });
    },
    switchPaymentTabsByArrow: function () {
        $('.payment-options .nav-item').on('keydown', function (e) {
            if (e.key === 'ArrowRight') {
                $(this).nextAll('.nav-item:first').find('a').trigger('focus')
                    .trigger('click');
            }
            if (e.key === 'ArrowLeft') {
                $(this).prev('.nav-item:first').find('a').trigger('focus')
                    .trigger('click');
            }
        });
    },
    modifyPostalCode: function () {
        $(document).on('change, blur', '#billingpostalCode', function (e) {
            var country = $('.billingCountry').val();
            var postalCode = $(e.currentTarget).val();
            e.stopPropagation();
            e.preventDefault();
            if (!country && postalCode.length > 0) {
                $('.billingCountry').trigger('blur');
                return;
            }
            if (postalCode == null || postalCode.length < 1) {
                return;
            }
            var isZipCodeValid = false;
            var zipCodeSelector = '.billing-address-block .billingpostalCode';
            import('../zipCodes').then(function (zipCodes) {
                if (country.length > 0 && postalCode.length > 0) {
                    isZipCodeValid = utils.isZipCodeValid(postalCode, country, zipCodeSelector, zipCodes.zipCodeJSON);
                }
                if (isZipCodeValid) {
                    var getCityFromZip = $('.billing-information').attr('data-cityfromzip');
                    if (country === 'ZA' && getCityFromZip && getCityFromZip !== 'false') {
                        // autofillCityState(postalCode, country);
                        import('../province').then(function (province) {
                            province.autofillCityState(postalCode, country, 'billingcity', 'billingstateCode');
                        });
                    }
                }
            });
        });
    },
    validateBillingBlur: validateBillingBlur
};
